import { render, staticRenderFns } from "./TableIndex.vue?vue&type=template&id=a056d9ca&scoped=true&"
import script from "./TableIndex.vue?vue&type=script&lang=js&"
export * from "./TableIndex.vue?vue&type=script&lang=js&"
import style0 from "./TableIndex.vue?vue&type=style&index=0&id=a056d9ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a056d9ca",
  null
  
)

export default component.exports